

















import mixins from 'vue-typed-mixins';
import FunctionalCenterForm from '@/components/functionalcenter/FunctionalCenterForm.vue';
import FunctionalCenterUtils, {
  FunctionalCenter,
} from '@/utils/FunctionalCenterUtils';
export default mixins().extend({
  components: {
    FunctionalCenterForm,
  },
  computed: {
    id(): number {
      return parseInt(this.$route.params.functionalCenterId);
    },
  },
  data(): {
    functionalcenter?: FunctionalCenter;
  } {
    return {
      functionalcenter: undefined,
    };
  },
  async mounted() {
    try {
      this.functionalcenter = await FunctionalCenterUtils.api.get(this.id);
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async submit() {
      try {
        if (this.functionalcenter) {
          this.$alert.hide('submit');
          await FunctionalCenterUtils.api.update(this.functionalcenter);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.functionalcenter.label')],
            }),
          });
        }
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
